// 获取 URL 参数
export const getUrlParam = (name) => {
  const url = new URL(window.location.href)
  return url.searchParams.get(name)
}

// 扁平数据转换为一个树形结构
export const buildOrgTree = (data, id, parentId, children) => {
  const config = {
    id: id || 'id',
    parentId: parentId || 'parentId',
    childrenList: children || 'children',
  }

  const childrenListMap = {}
  const tree = []
  for (const d of data) {
    const id = d[config.id]
    childrenListMap[id] = d
    if (!d[config.childrenList]) {
      d[config.childrenList] = []
    }
  }

  for (const d of data) {
    const parentId = d[config.parentId]
    const parentObj = childrenListMap[parentId]
    if (parentObj) {
      parentObj[config.childrenList].push(d)
    } else {
      tree.push(d)
    }
  }
  return tree
}

export const closeWindow = () => {
  if (document.addEventListener) {
    document.addEventListener(
      'WeixinJSBridgeReady',
      function () {
        window.WeixinJSBridge && window.WeixinJSBridge.call('closeWindow')
        parent.WeixinJSBridge.call('closeWindow')
      },
      false,
    )
  } else if (document.attachEvent) {
    document.attachEvent('onWeixinJSBridgeReady', function () {
      // 这个可以关闭ios系统的手机
      window.WeixinJSBridge && window.WeixinJSBridge.call('closeWindow')
    })
  }
  // 非ios处理
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    console.log('iOS') // iOS
  } else {
    window.WeixinJSBridge && window.WeixinJSBridge.call('closeWindow')
  }
  // Pc端处理
  window.close && window.close()
}

export const getNonce = () => {
  const chars = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
  ]
  let res = ''
  for (let i = 0; i < 6; i++) {
    const id = Math.ceil(Math.random() * 35)
    res += chars[id]
  }
  return res
}
